module.exports = __webpack_public_path__ + "static/acupun_1-adaff307a40869f3a2d49a39a7ee5c6b.webp";